import React, { Component } from 'react';

export default class FixedButton extends Component {
    state={

    };
    constructor(props) {
        super(props);
    };
    render () {
        return (
            <div className='button-container'>
                <a  href={'#' + this.props.id} className='full-fill' >
                <img className='fill-y' src={this.state.hover? this.props.srcOn:this.props.src} onMouseEnter={this.mouseIn} onMouseLeave={this.mouseOut}/>
                </a>
            </div>
        )};
    mouseIn=()=>{this.setState({hover: true});};
    mouseOut=()=>{this.setState({hover: false});};
}
